<template>
	<div>

		<div class="content_box">
			<div class="title">
				<span class="left_shu"></span>
				监测首页
			</div>
			<div class="environment_box" style="padding: 10px 0;">
				<a-table :columns="columns" :data-source="data">
				</a-table>
			</div>
		</div>

		<div class="content_box" style="margin-top: 16px;">
			<div class="title">
				<span class="left_shu"></span>
				空气监测统计图
			</div>
			<div style="padding: 30px 0;">

				<div id="myChart">

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	const columns = [{
			title: '序号',
			dataIndex: 'id',
			align: 'center',
		},
		{
			title: '站名',
			dataIndex: 'name',
			align: 'center',
		},
		{
			title: '站号',
			dataIndex: 'number',
			align: 'center',
		},
		{
			title: '类型',
			dataIndex: 'type',
			align: 'center',
		},
		{
			title: '经度',
			dataIndex: 'longitude',
			align: 'center',
		},
		{
			title: '纬度',
			dataIndex: 'latitude',
			align: 'center',
		},
		{
			title: '海拔',
			dataIndex: 'altitude',
			align: 'center',
		},
		{
			title: '创建时间',
			dataIndex: 'creatime',
			align: 'center',
		},
		{
			title: '操作',
			dataIndex: 'tags',
			scopedSlots: {
				customRender: 'tags'
			},
			align: 'center',
			width: '120px'
		},
	];
	
	const data = [{
			id: '1',
			name: '测试站点1',
			number: 'HYC—360',
			type: '交通气象',
			longitude: '138.54125',
			latitude: '32.15624',
			altitude: '12.2',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '2',
			name: '测试站点2',
			number: 'HYC—360',
			type: '交通气象',
			longitude: '138.54125',
			latitude: '32.15624',
			altitude: '12.2',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '3',
			name: '测试站点3',
			number: 'HYC—360',
			type: '交通气象',
			longitude: '138.54125',
			latitude: '32.15624',
			altitude: '12.2',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '4',
			name: '测试站点4',
			number: 'HYC—360',
			type: '交通气象',
			longitude: '138.54125',
			latitude: '32.15624',
			altitude: '12.2',
			creatime: '2021-01-08 13:58:03',
		},
		{
			id: '5',
			name: '测试站点1',
			number: 'HYC—360',
			type: '交通气象',
			longitude: '138.54125',
			latitude: '32.15624',
			altitude: '12.2',
			creatime: '2021-01-08 13:58:03',
		},
	];
	
	export default {
		data() {
			return {
				data, //表格内容
				columns, //表格头部
				width: 0
			}
		},
		mounted() {
			this.drawLine();
		},
		methods: {
			drawLine() {
				// 基于准备好的dom，初始化echarts实例
				console.log(this.$eachrts)
				let myChart = this.$echarts.init(document.getElementById('myChart'))
				// 绘制图表
				myChart.setOption({
					backgroundColor: '#fff',
					// title: {
					// 	text: '多线图',
					// 	textStyle: {
					// 		align: 'center',
					// 		color: '#fff',
					// 		fontSize: 20,
					// 	},
					// 	top: '20%',
					// 	left: 'center',
					// },
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							lineStyle: {
								color: {
									type: 'linear',
									x: 0,
									y: 0,
									x2: 0,
									y2: 1,
									colorStops: [{
										offset: 0,
										color: 'rgba(255, 255, 255,0)',
									}, ],
									global: false,
								},
							},
						},
					},
					grid: {
						top: '15%',
						left: '5%',
						right: '5%',
						bottom: '15%',
						// containLabel: true
					},
					xAxis: [{
						type: 'category',//坐标轴类型
						axisLine: {
							show: true,//是否显示坐标轴轴线
							lineStyle: {
								color: '#E4E4E4',//坐标轴轴线颜色
							},
						},
						axisLabel: {
							show:true,//是否显示刻度标签
							color: '#999',//刻度标签文字的颜色
						},

						splitLine: {
							show: false,//是否显示分隔线
						},
						axisTick: {
							show: false,//是否显示坐标轴刻度
						},
						boundaryGap: false,//坐标轴两边留白策略
						data: ['00点', '02点', '04点', '06点', '08点', '10点', '12点', '14点', '16点', '18点', '20点','22点'],
					}, ],

					yAxis: [{
						type: 'value',
						min: 0,
						// max: 140,
						splitNumber: 4,
						splitLine: {
							show: true,
						},
						axisLine: {
							show: true,
							lineStyle: {
								color: '#E4E4E4',//坐标轴轴线颜色
							},
						},
						axisLabel: {
							show: true,
							margin: 20,
							textStyle: {
								color: '#999999',
							},
						},
						axisTick: {
							show: false,
						},
					}, ],
					series: [{
						name: '注册总量',
						type: 'line',
						smooth: true, //是否平滑
						showAllSymbol: true,
						// symbol: 'image://./static/images/guang-circle.png',
						symbol: 'circle',
						symbolSize: 15,
						label: {
							show: true,
							position: 'top',
							textStyle: {
								color: '#7F86E9',
							},
						},

						itemStyle: {
							color: '#7F86E9',
							borderColor: '#fff',
							borderWidth: 1,
							shadowColor: 'rgba(0, 0, 0, .3)',
							shadowBlur: 0,
							shadowOffsetY: 1,
							shadowOffsetX: 1,
						},
						tooltip: {
							show: false,
						},
						areaStyle: {
							normal: {
								color: new this.$echarts.graphic.LinearGradient(
									0,
									0,
									0,
									1,
									[{
											offset: 0,
											color: 'rgba(127,134,233,0.3)',
										},
										{
											offset: 1,
											color: 'rgba(127,134,233,0)',
										},
									],
									false
								),
								shadowColor: 'rgba(127,134,233, 0.9)',
								shadowBlur: 20,
							},
						},
						data: [12.5, 28.3, 21.5, 28.6, 12, 27, 28.6, 15, 21.5, 28.7, 27.5, 29.3],
					}, ],
				});
			}
		}
	}
</script>

<style>
	@import url("../../assets/css/common.css");
.content_box .title{
	margin-bottom: 10px;
}
	.environment_box {
		padding: 10px 30px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-around;
		position: relative;
	}
	.ant-table-wrapper{
		width: 100%;
	}

	.environment_list {
		display: flex;
		width: 25%;
		justify-content: center;
		height: 120px;
		align-items: center
	}

	.environment_list:nth-child(-n+3) {
		border-right: 1px solid #D9D9D9;
	}

	.environment_list:nth-child(-n+4) {
		border-bottom: 1px solid #D9D9D9;
	}

	.environment_list:nth-child(n+5) {
		border-right: 1px solid #D9D9D9;
	}

	.environment_list:last-child {
		border: none;
	}

	.environment_list img {
		width: 70px;
		height: 70px;
	}

	.environment_right {
		padding-left: 20px;
	}

	.environment_right .environment_title {
		line-height: 30px;
		font-size: 14px;
		color: #999;
	}

	.environment_right .environment_value {
		color: #666;
		font-size: 18px;
		font-weight: bold;
	}

	.environment_right .environment_value span {
		font-size: 12px;
		font-weight: 400;
	}

	#myChart {
		height: 200px;
	}
</style>
